import { MenuService } from './../services/menu.service';
import { Component, EventEmitter, Output } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { MatIconButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    imports: [MatIconButton, RouterOutlet, TranslateModule]
})
export class SidebarComponent {

  @Output()
  closeDrawer = new EventEmitter();

  constructor(
    public router: Router,
    public menuService: MenuService,
  ) {}


}
